import { useEffect } from "react";

import { config } from "config";

import { useUserInfo } from "../useUserInfo/useUserInfo";

import {
  QUALTRICS_SCRIPT_ID,
  injectQualtricsScript,
} from "./useInjectQualtrics.helpers";

export const useInjectQualtrics = () => {
  const { isAuthenticated, userId } = useUserInfo();

  useEffect(() => {
    const scriptExists = !!document.getElementById(QUALTRICS_SCRIPT_ID);

    if (
      window.location.pathname !== "/" &&
      !scriptExists &&
      userId &&
      isAuthenticated
    ) {
      injectQualtricsScript({
        brandId: config.CPG_QUALTRICS_BRAND_ID,
        id: config.CPG_QUALTRICS_ID,
        userId,
      });
    }
  }, [userId, isAuthenticated]);
};
